// The CSV template offered in the import wizard. Header + a few EXAMPLE
// rows (clearly marked for deletion) covering the common device classes.
// Kept in sync with docs/layout-import-template.csv and the format
// reference in docs/layout-import.md.

export const LAYOUT_CSV_TEMPLATE = [
  "floor_slug,floor_label,floor_level,area_slug,area_label,area_space_type,device_class,slot_index,location_note,tuya_local_key,tuya_device_id,panel_relay_count,camera_stream_key,inverter_serial,mac,model,notes",
  "ground,Ground,0,example-lounge,Example Lounge,lounge,switch_panel,1,entry wall,REPLACE_TUYA_KEY,REPLACE_TUYA_ID,6,,,,Moes 6-gang,EXAMPLE ROW - delete before import",
  "ground,Ground,0,example-lounge,Example Lounge,lounge,air_conditioner,1,,REPLACE_TUYA_KEY,REPLACE_TUYA_ID,,,,,,EXAMPLE ROW - delete before import",
  "first,First Floor,1,example-bedroom,Example Bedroom,bedroom,ceiling_fan,1,,REPLACE_TUYA_KEY,REPLACE_TUYA_ID,,,,,,EXAMPLE ROW - delete before import",
  "ground,Ground,0,example-garage,Example Garage,garage,frigate_camera,1,,,,,garage_panoramic,,,Reolink,EXAMPLE ROW - delete before import",
  "",
].join("\n");

export function downloadLayoutTemplate(): void {
  const blob = new Blob([LAYOUT_CSV_TEMPLATE], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "layout-template.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
